var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('div',{staticClass:"flex h-full items-center justify-center"},[_c('spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }